import { HrpBaseClient } from './HrpBaseClient'

export class HrpClaimsClient extends HrpBaseClient {
    constructor(
        hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
        hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
        axiosOptions
    ) {
        super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
    }

    async getClaimsView({ memberKey, claimHccId }) {
        await this.createSecureAxiosInstance()

        const searchParams = {
            memberKey,
            claimHccId
        }

        try {
            const response = await this.secureAxiosInstance.get(`/admin/api/claim/db/getClaimsView`, {
                params: searchParams
            })

            return response.data
        }
        catch (e) {
            throw e.response
        }
    }

    async getClaimLetterDetails(params) {
        await this.createSecureAxiosInstance()

        try {
            const response = await this.secureAxiosInstance.get(`/admin/api/claim/db/getClaimLetterDetails`, {
                params
            });

            return response.data;
        } catch (e) {
            throw e.response;
        }
    }

    async getClaimDetailsByHccIDList({
        claimHccNumber,
        claimDetailFlags,
        claimFilterParameters,
    }) {
        await this.createSecureAxiosInstance()

        try {
            const response = await this.secureAxiosInstance.post(`/admin/api/claim/classic/getClaimDetailsByHccIDList`, {
                claimHccNumber,
                claimDetailFlags,
                claimFilterParameters,
            })

            return response.data
        }
        catch (e) {
            throw e.response
        }
    }

    async findPayments({
        paymentNumber,
        paymentBatchNumber
    }) {
        await this.createSecureAxiosInstance()

        const paymentNumberToNumber = Number(paymentNumber);
        if (isNaN(paymentNumberToNumber)) {
            throw new Error(`Invalid payment number: ${paymentNumber}`);
        }
        const paymentBatchNumberToNumber = Number(paymentBatchNumber)
        if (isNaN(paymentBatchNumberToNumber)) {
          throw new Error(`Invalid payment batch number: ${paymentBatchNumber}`);
      }

        try {
            const response = await this.secureAxiosInstance.post(`/admin/api/payment/classic/findPayments`, {
                criteria: {
                    paymentNumber: paymentNumberToNumber,
                    paymentBatchNumber: paymentBatchNumberToNumber
                }
            })

            return response.data
        }
        catch (e) {
            throw e.response
        }
    }

    async getPaymentDetailsByID({
        paymentId,
        paymentDetailFlags
    }) {
        await this.createSecureAxiosInstance()

        const paymentIdToNumber = Number(paymentId);
        if (isNaN(paymentIdToNumber)) {
            throw new Error(`Invalid payment number: ${paymentIdToNumber}`);
        }

        try {
            const response = await this.secureAxiosInstance.post(`/admin/api/payment/classic/getPaymentDetailsByID`, {
                paymentId,
                paymentDetailFlags
            })

            return response.data
        }
        catch (e) {
            throw e.response
        }
    }

    async getClaimsByMemberHccId({
        memberHccId,
        limit,
        offset,
        claimTypeName,
        claimStatus
    }) {
        await this.createSecureAxiosInstance()

        const searchParams = {
            memberHccId,
            limit,
            offset,
            claimTypeName,
            claimStatus
        }

        try {
            const response = await this.secureAxiosInstance.get(`/admin/api/claim/db/getClaimsByMemberHccId`, {
                params: searchParams
            })

            return response.data
        }
        catch (e) {
            throw e.response
        }
    }

    async findClaims({
        claimState,
        claimType,
        dentalTransactionType,
        processingTimeRangeStart,
        processingTimeRangeEnd,
        receiptDateStart,
        receiptDateEnd,
        payeeType,
    }) {
        await this.createSecureAxiosInstance()

        try {
            const response = await this.secureAxiosInstance.post(`/admin/api/claim/classic/findClaims`, {
                criteria: {
                    claimState,
                    claimType,
                    dentalTransactionType,
                    processingTimeRangeStart,
                    processingTimeRangeEnd,
                    receiptDateStart,
                    receiptDateEnd,
                    payeeType,
                }
            });

            return response.data;
        } catch (e) {
            throw e.response;
        }
    }

    async getClaimFactByCurClaimHccId({ claimHccId }) {
        await this.createSecureAxiosInstance()

        if (!claimHccId) {
            throw new Error('claimHccId is required');
        }

        try {
            const response = await this.secureAxiosInstance.get(`/admin/api/claim/db/getClaimFactByCurClaimHccId`, {
                params: { claimHccId }
            });

            return response.data;
        } catch (e) {
            throw e.response;
        }
    }
}
